import { render, staticRenderFns } from "./SensitiveManage.vue?vue&type=template&id=7f806c52&scoped=true"
import script from "./SensitiveManage.vue?vue&type=script&lang=js"
export * from "./SensitiveManage.vue?vue&type=script&lang=js"
import style0 from "./SensitiveManage.vue?vue&type=style&index=0&id=7f806c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f806c52",
  null
  
)

export default component.exports